@app.directive 'textBlock', ($filter, $compile, $sanitize)->
  restrict: 'E'
  scope: {}
  controllerAs: 'textBlock'
  controller: ->

    this

  bindToController: {
    theme: '='
    content: '='
  }
  link: (scope, element, attrs) ->

  templateUrl: "/assets/templates/components/textBlock/textBlock.html"
